module.exports = __webpack_public_path__ + "img/img1.53fd03c0.jpg";